module.exports = __webpack_public_path__ + "static/img/79.225052a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/79.png
// module id = EKmP
// module chunks = 1